const routes = {
  '/': 'Trang chủ',
  '/users': 'Danh sách nhân viên',
  '/activities': 'Lịch sử hoạt động',
  '/activity-types': 'Loại hoạt động',
  '/roles': 'Quản lý nhóm người dùng',
  '/role-edit': 'Thông tin nhóm người dùng',
  '/nganhhang': 'Quản lý nhóm sản phẩm',
  '/nganhhang-edit': 'Thông tin nhóm sản phẩm',
  '/nhacungcap': 'Quản lý nhà cung cấp',
  '/nhacungcap-edit': 'Thông tin nhà cung cấp',
  '/kho': 'Quản lý kho',
  '/kho-edit': 'Thông tin kho',
  '/products': 'Quản lý sản phẩm',
  '/products-edit': 'Thông tin sản phẩm',
  '/nguoidung-kho': 'Thêm người dùng vào kho',
  '/chuong-trinh': 'Chương trình khuyến mãi',
  '/chuong-trinh-edit': 'Quản lý các chương trình khuyến mãi',
  '/chuong-trinh-product': 'Quản lý sản phẩm theo chương trình khuyến mãi',
  '/nguoidung-role': 'Thêm người dùng vào nhóm',
  '/imports': 'Danh sách phiếu nhập',
  '/nhap-kho': 'Nhập hàng',
  '/nhap-kho-edit': 'Sửa nhập hàng',
  "/orders/1": "Đơn hàng",
  "/orders/2": "Đơn đại lý",
  "/processorders/1": "Đơn hàng xuất kho",
  "/processorders/2": "Đơn đại lý xuất kho",
  "/order/1": "Đặt đơn",
  "/order/2": "Đặt đơn đại lý",
  "/order-view/1": "Xem đơn hàng",
  "/order-view/2": "Xem đơn đại lý",
  "/order-view/3": "Xem đơn huỷ",
  "/order-edit/1": "Sửa đơn hàng",
  "/order-edit/2": "Sửa đơn đại lý",
  '/khachhang': 'Quản lý khách hàng',
  '/khachhang-edit': 'Thông tin khách hàng',
  '/khachhang-user': 'Khách hàng - quản lý',
  '/tonkho': 'Danh sách sản phẩm tồn kho',
  '/tonkho-edit': 'Cập nhật số lượng sản phẩm tồn kho',
  '/import-report': 'Báo cáo nhập hàng',
  '/guest-report': 'Báo cáo theo khách hàng',
  '/order-report': 'Báo cáo đơn hàng',
  '/sale-total-report': 'Độ phủ nghành hàng',
  '/sale-detail-report': 'Báo cáo chi tiết khách hàng',
  '/sale-report': 'Báo cáo doanh số',
  '/giaohang': 'Giao hàng',
  '/giaohang-edit': 'Chi tiết giao hàng',
  '/permission-role': 'Thêm quyền cho nhóm người dùng',
  '/hop-dong': 'Danh sách hợp đồng',
  '/chi-tiet-hop-dong': 'Thông tin hợp đồng',
  '/tra-hang': 'Đơn trả hàng',
  '/setting': 'Cấu hình hệ thống',
  '/process-order-detail': 'Chi tiết phiếu xuất',
  '/process-order-checkqr': 'Xác nhận phiếu xuất kho',
  '/process-order-checked': 'Danh sách phiếu xuất kho',
  '/checkin': 'Checkin người dùng',
  '/checkin-report': 'Báo cáo checkin',
  '/muc-hop-dong': 'Mức hợp đồng',
};
export default routes;



// WEBPACK FOOTER //
// ./src/routes.js